// PRODUCTS ENDPOINTS
export const GET_ALL_PRODUCTS = '/getall/products/list?isPaginated=true';
export const GET_SINGLE_PRODUCT = '/get/product';

// ADDRESS ENDPOINTS
export const ADD_ADDRESS = '/account/delivery-address/insert';
export const UPDATE_ADDRESS = '/delivery/address/update';
export const DELETE_ADDRESS = '/delivery/address/delete';
export const GET_ADDRESS = '/get/delivery/address';
export const CHECK_BILLING_ADDRESS = '/get/delivery/billing-address/check';
export const UPDATE_BILLING_ADDRESS = '/delivery/billing-address/update';

// PINCODE ENDPOINTS
export const CHECK_PINCODE_SERVICE = '/delivery/serviceable-pincode';

// CART
export const ADD_TO_CART = '/cart';
export const GET_CART_SUMMERY = '/cart';

// ORDER ENDPOINTS
export const ORDER = '/delivery/order';

// Payment Status ENDPOINTS
export const PAYMENT_LIMIT = '/delivery/payment/limit/check'
  

// CONSTANT VALUE
export const SUCESS = 'captured';

// FAQ ENDPOINTS
export const FAQS = '/delivery/faq';





